import { Link } from 'react-router-dom';

export default function SubmitCta() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-16" aria-labelledby="cta-title">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-secondary-800">
        <div className="grid grid-cols-1 items-center gap-8 p-6 md:p-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-3 py-1 font-label text-xs font-medium text-background-50">
              <i className="ri-megaphone-line text-sm"></i>
              线索征集
            </span>
            <h2 id="cta-title" className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              手上也有料？欢迎来爆料
            </h2>
            <p className="mt-3 max-w-2xl font-body text-sm leading-relaxed text-secondary-100">
              无论是你在现场看到的画面，还是圈内朋友提到的消息，都可以通过投稿入口告诉我们。编辑会先做核实，再决定是否整理成文。所有线索来源都会匿名处理。
            </p>
          </div>
          <div className="flex flex-col gap-3 lg:items-end">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line mr-2 text-base"></i>
              我要爆料
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-secondary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-secondary-700"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}